import { LinkStyledAsButton as StageTenLinkStyledAsButton } from "@lazarentertainment/web-design-system/components/button"
import { ComponentPropsWithoutRef, forwardRef } from "react"

import { buttonSizes, buttonVariants } from "./Button"

export type LinkStyledAsButtonProps = Omit<
  ComponentPropsWithoutRef<typeof StageTenLinkStyledAsButton>,
  "variant" | "size"
> & {
  variant?: (typeof buttonVariants)[number]
  size?: (typeof buttonSizes)[number]
}

export const LinkStyledAsButton = forwardRef<
  HTMLAnchorElement,
  LinkStyledAsButtonProps
>(({ variant = "primary", size = "md", children, ...props }, ref) => {
  return (
    <StageTenLinkStyledAsButton
      data-variant={variant}
      data-size={size}
      ref={ref}
      {...props}
    >
      {children}
    </StageTenLinkStyledAsButton>
  )
})
